export enum ContactChildTab {
  Properties = 'settings/customer/property',
  Blacklist = 'settings/customer/blacklist',
  Group = 'settings/customer/group',
}

export const ContactTabList = [
  {
    id: ContactChildTab.Properties,
    title: 'Thuộc tính mở rộng',
  },
  {
    id: ContactChildTab.Group,
    title: 'Nhóm khách hàng',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(ContactChildTab).forEach(s => {
    if (url.includes(ContactChildTab[s])) {
      tab = ContactChildTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/contact.const.ts